import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll () {
    return store.dispatch('checkResponseApi', await Api().get('channel/notifications'))
  },

  async getSingle (data) {
    let param = 'ch_noti_id=' + data.ch_noti_id
    return store.dispatch('checkResponseApi', await Api().get('channel/notification?' + param))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('channel/notification', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('channel/notification', data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('channel/notification', { data: data }, options))
  },

}



// WEBPACK FOOTER //
// ./src/api/ChannelNoti.js